import { Box, Button, Stack, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../../theme";
import { useTheme } from "@mui/material";
import { myNFTs } from "../../../data/dummyNfts";
import styled from "@emotion/styled";
import { nftTempImage, ON_LEND } from "../../../constants";
import { conciseAddress } from "../../../utils/formatters";

const StyledButton = styled(Button)(({ theme, colors, selected }) => ({
  backgroundColor: selected ? colors.primary[500] : colors.whiteAccent[900],
  color: selected ? colors.whiteAccent[900] : colors.primary[500],
  fontSize: "14px",
  fontWeight: 400,
  width: "95px",
  height: "38px",
  borderRadius: "7px",
  borderColor: colors.primary[500],
  "&:hover": {
    backgroundColor: colors.primary[600],
    borderColor: colors.primary[500],
    color: colors.whiteAccent[900],
  },
}));

const TableView = ({ data, setNftStaesOnSelect, setFilteredNfts }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const columns = [
    {
      field: "name",
      headerName: "Item",
      flex: 0.5,
      sortable: false,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <Stack direction="row" alignItems={"center"} justifyContent="center">
          <img
            src={params.row.image}
            onError={(e) => (e.currentTarget.src = nftTempImage)}
            alt="nft"
            style={{ width: "44px", height: "55px", borderRadius: "13px" }}
          />
          <Stack direction="column" ml={"10px"}>
            <Typography
              variant="caption"
              color={colors.black[500]}
              fontWeight={500}
            >
              {params.row.name}
            </Typography>
            <Typography
              variant="fs13"
              color={colors.black[800]}
              fontWeight={500}
            >
              {params.row.tokenId}
            </Typography>
          </Stack>
        </Stack>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.5,
      sortable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "nftAddress",
      headerName: "Address",
      sortable: false,
      flex: 0.5,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography variant="fs16" color={colors.black[500]} fontWeight={500}>
          {conciseAddress(params.row.nftAddress)}
        </Typography>
      ),
    },
    {
      field: "select",
      headerName: "Status",
      flex: 0.5,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <StyledButton
          onClick={() => {
            let copyData = [...data];

            copyData[params.api.getRowIndex(params.row.id)] = {
              ...params.row,
              selected: !params.row.selected,
            };
            console.log("copyData after", copyData);
            if (setFilteredNfts) setFilteredNfts(copyData);
            setNftStaesOnSelect(copyData, params.row);
          }}
          selected={params.row.selected}
          disabled={params.row.status === ON_LEND}
          colors={colors}
        >
          {params.row.selected ? "Selected" : "Select"}
        </StyledButton>
      ),
    },
  ];

  return (
    <Box m="0px 0 0 20px" width="96%">
      <Box
        // m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
            outline: "none !important",
          },
          "& .MuiDataGrid-row": {
            height: "98px !important",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "1px solid #E8ECF5",
            outline: "none !important",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.whiteAccent[500],
            borderBottom: "none",
            outline: "none !important",
          },
          "& .MuiDataGrid-columnHeader": {
            outline: "none !important",
          },
          "& .MuiDataGrid-columnSeparator": {
            visibility: "hidden",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.whiteAccent[500],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.whiteAccent[500],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={data}
          columns={columns}
          getRowId={(row) => row.id}
          density="comfortable"
          disableColumnSelector={true}
          disableColumnFilter={true}
          disableColumnMenu={true}
          disableSelectionOnClick={true}
          hideFooter={true}
        />
      </Box>
    </Box>
  );
};

export default TableView;
